import { render } from "./BrandSettings.vue?vue&type=template&id=a7e9120e"
import script from "./BrandSettings.vue?vue&type=script&lang=js"
export * from "./BrandSettings.vue?vue&type=script&lang=js"

import "./BrandSettings.vue?vue&type=style&index=0&id=a7e9120e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__